import { IBaseAction } from "../Actions/BaseAction";

export type GetUSAWKTInitiateAction = IBaseAction<void>;
export type GetUSAWKTSuccessAction = IBaseAction<string>;
export type GetUSAWKTFailureAction = IBaseAction<string>;

export type GetRedirectLinkInitiateAction = IBaseAction<string>;
export type GetRedirectLinkFailureAction = IBaseAction<string>;

export type CommonActionType =
    GetUSAWKTInitiateAction
    | GetUSAWKTSuccessAction
    | GetUSAWKTFailureAction
    ;

export const GET_USA_WKT_INITIATE = "GET_USA_WKT_INITIATE";
export const GET_USA_WKT_SUCCESS = "GET_USA_WKT_SUCCESS";
export const GET_USA_WKT_FAILURE = "GET_USA_WKT_FAILURE";
export const GET_REDIRECT_LINK_INITIATE = "GET_REDIRECT_LINK_INITIATE";
export const GET_REDIRECT_LINK_FAILURE = "GET_REDIRECT_LINK_FAILURE";